<template>
  <div>
    <el-form
      ref="searchForm"
      :inline="true"
      :size="'small'"
      :label-position="position"
    >
      <el-form-item label="门店">
        <el-select
          v-model="currentShopStore"
          multiple
          clearable
          placeholder="请选择"
          filterable
        >
          <el-option
            v-for="(item, index) in shopStoreList"
            :key="index"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="地址">
        <template slot="label">
          <span class="form-question">
            <el-tooltip
              content="根据地址详情进行标记点: 北京市海淀区彩和坊路海淀西大街74号"
              placement="top"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
            地址详情
          </span>
        </template>
        <el-input
          v-model="currentAddress"
          clearable
          @clear="handlerAddressClear"
          style="min-width: 250px;"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="geocoder"
          ></el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <el-form
      ref="searchForm"
      :inline="true"
      :size="'small'"
      :label-position="position"
    >
      <el-form-item label="订单状态">
        <el-select
          v-model="currentOrderState"
          multiple
          clearable
          placeholder="请选择"
          @change="queryData"
        >
          <el-option
            v-for="(item, index) in orderState"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="orderDate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          @change="queryData"
          :clearable="false"
        >
        </el-date-picker>
      </el-form-item>
    </el-form>
    <div id="container"></div>
  </div>
</template>
<script>
import TXMap2 from "../../components/orderMap/TXMap2";
import {
  queryAddressGeocoder,
  queryShopStoreOrderMap,
  shopStoreList
} from "../../api/api";
import { hideLoading, showLoading } from "../../components/loading/loading";
export default {
  data() {
    return {
      selectValue: "",
      position: "left",
      longitude: 0, //经度
      latitude: 0, //纬度
      city: "shanghai",
      orderState: [
        {
          label: "待确认",
          value: "01"
        },
        {
          label: "待派单",
          value: "03"
        },
        {
          label: "待出发",
          value: "05"
        }
      ],
      orderDate: [
        new Date(new Date().getFullYear, new Date().getMonth(), 1),
        new Date(new Date().getFullYear, new Date().getMonth() + 1, 0)
      ],
      shopStoreList: [],
      currentAddress: "",
      currentShopStore: [],
      currentShopStoreList: [],
      currentOrderState: [],
      map: null,
      marker: null
    };
  },
  watch: {
    currentShopStore(newVal, oldVal) {
      TXMap2.removeGeometries(oldVal);
      TXMap2.removeMultiLabels(oldVal);
      this.currentShopStoreList = this.shopStoreList.filter(e =>
        newVal.includes(e.id)
      );
      this.currentShopStoreList.forEach(e => {
        TXMap2.addGeometries(e);
        e.label = e.name;
        TXMap2.addMultiLabel(e);
      });
    }
  },
  mounted() {
    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.orderDate = [firstDay, lastDay];
    this.queryShopStoreList();
    TXMap2.txMap({ containerId: "container", useLocation: true });
    TXMap2.initMarker();
    TXMap2.initMarkerCluster();
    TXMap2.initMultiCircle();
    TXMap2.initMultiLabel();
    this.queryData();
  },
  methods: {
    queryShopStoreList() {
      shopStoreList({ status: 1 }).then(res => {
        if (res.data.status == "100") {
          this.shopStoreList = res.data.results;
        }
      });
    },
    queryData() {
      const body = {};
      if (this.orderDate && this.orderDate.length > 0) {
        body.beginDate = this.orderDate[0];
        body.endDate = this.orderDate[1];
      }
      if (this.currentOrderState && this.currentOrderState.length > 0) {
        body.orderStateList = this.currentOrderState;
      }
      queryShopStoreOrderMap(body).then(res => {
        if (res.data.status == 100) {
          TXMap2.setMarkerAndMakerCluster(res.data.results);
        }
      });
    },
    /**
     * 解析地址
     */
    geocoder() {
      if (!this.currentAddress) {
        this.$message({
          message: "请输入详情地址信息",
          type: "warning"
        });
        return;
      }
      queryAddressGeocoder({ address: this.currentAddress }).then(res => {
        console.log(res);
        if (res.data.status == "100") {
          const { lat, lng } = res.data.results;
          if (lat && lng) {
            TXMap2.addAddressMarker(lat, lng);
          } else {
            this.$message({
              message: "解析失败,请查看解析地址",
              type: "warning"
            });
          }
        } else {
          this.$message({ message: this.data.message, type: "warning" });
        }
      });
    },
    /**
     * 移除
     */
    handlerAddressClear() {
      TXMap2.removeAddressMarker();
    }
  }
};
</script>
<style>
/* #container {
  width: 98%;
  height: 100%;
  position: absolute;
} */
.clusterBubble1 {
  position: absolute;
  width: 40px;
  height: 40px;
  border-radius: 40px;
  text-align: center;
  line-height: 40px;
  box-shadow: rgb(0 0 0 / 20%) 0px 1px 1px 0px;
  border: 1px solid rgb(192, 192, 192);
  background-color: rgba(227, 235, 255, 0.9);
  font-size: 14px;
  color: rgb(192, 192, 192);
}
.clusterBubble2 {
  position: absolute;
  width: 40px;
  height: 40px;
  border-radius: 40px;
  text-align: center;
  line-height: 40px;
  box-shadow: rgb(0 0 0 / 20%) 0px 1px 1px 0px;
  border: 1px solid rgb(255, 162, 0);
  background-color: rgba(227, 235, 255, 0.9);
  font-size: 14px;
  color: rgb(255, 162, 0);
}
.clusterBubble3 {
  position: absolute;
  width: 40px;
  height: 40px;
  border-radius: 40px;
  text-align: center;
  line-height: 40px;
  box-shadow: rgb(0 0 0 / 20%) 0px 1px 1px 0px;
  border: 1px solid rgb(160, 32, 240);
  background-color: rgba(227, 235, 255, 0.9);
  font-size: 14px;
  color: rgb(160, 32, 240);
}
.clusterBubble4 {
  position: absolute;
  width: 40px;
  height: 40px;
  border-radius: 40px;
  text-align: center;
  line-height: 40px;
  box-shadow: rgb(0 0 0 / 20%) 0px 1px 1px 0px;
  border: 1px solid rgb(255, 0, 0);
  background-color: rgba(227, 235, 255, 0.9);
  font-size: 14px;
  color: rgb(255, 0, 0);
}
</style>



// WEBPACK FOOTER //
// shopStoreOrderMap.vue?1edd0cdf